module.exports = __webpack_public_path__ + "static/img/enter_home_img2.6393b61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/enter_home_img2.png
// module id = XKaM
// module chunks = 26